// libs
import NFA from 'shared/helpers/analytics/NFAnalytics';

import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';

export const onReferSizeGuideClickTracking = (
  _location?: string, analyticsContext?: Record<string, unknown>
) => {
  NFA.track({
    event: PDP_EVENTS.SIZE_CHART_CLICK,
    ...(analyticsContext ? { data: analyticsContext } : {}),
  });
};

export const trackSizeGuideChartClosed = () => {
  NFA.track({
    event: PDP_EVENTS.SIZE_CHART_CLOSED,
  });
};

export const trackReviewViewed = () => {
  NFA.track({
    event: PDP_EVENTS.REVIEWS_VIEWED,
  });
};
